(function () {
  const sections = document.querySelectorAll('[data-barf-final-cta]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('fbfc-js');

    const revealItems = section.querySelectorAll('.fbfc-reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fbfc-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -42px 0px'
    });

    revealItems.forEach((item, index) => {
      if (!item.style.getPropertyValue('--fbfc-delay')) {
        item.style.setProperty('--fbfc-delay', `${index * 90}ms`);
      }
      observer.observe(item);
    });
  });
})();
